import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'

import { httpOk, GET } from 'helpers/api'
import { formatMoney, formatDate, returnSign } from 'helpers/helpers'

function SummaryExpense({ setActiveModal, filterData }) {
	const { t } = useTranslation()

	const [data, setData] = useState([])
	const [total, setTotal] = useState(0)
	const [totalSom, setTotalSom] = useState(0)
	const [totalUsd, setTotalUsd] = useState(0)

	async function searchWithFilter() {
		// MUHIM: ustun (Умумий хисобот -> Харажатлар) bilan bir manba — expenses jadvali.
		// Eski /report/expenses accounts_balance_history dan o'qir edi: konversiya kirar,
		// smenada qilingan xarajatlar esa umuman ko'rinmas edi.
		var filterUrl = "/report/summary-expenses"
		var urlParams = ""

		if (filterData.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + filterData.start_date
		if (filterData.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + filterData.end_date

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data.data || [])
			setTotal(response.data.total_amount || 0)
			setTotalSom(response.data.total_som || 0)
			setTotalUsd(response.data.total_usd || 0)
		}
	}

	useEffect(() => {
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<Modal show={true} animation={false} centered size="xl"
			onHide={() => setActiveModal(false)}>
			<Modal.Header closeButton>
				<Modal.Title>
					{t('expenses')}
					{filterData.start_date && filterData.end_date && filterData.start_date === filterData.end_date &&
						<span className="text-muted fz-14 ms-2">— {formatDate(filterData.start_date)}</span>
					}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="d-flex justify-content-end align-items-center gap-3 mb-3 flex-wrap">
					<h6 className="mb-0">
						<b>{t('total')}:</b>{' '}
						<span className="text-danger">{formatMoney(total)}</span>
					</h6>
					{Number(totalUsd) > 0 &&
						<span className="badge bg-warning text-dark" style={{ fontSize: '12px' }}>
							{formatMoney(totalSom)} so'm + {formatMoney(totalUsd)} $
						</span>
					}
				</div>

				<div className="table-responsive" style={{ maxHeight: '500px', overflowY: 'auto' }}>
					<table className="table table-bordered mb-0">
						<thead>
							<tr>
								<th style={{ minWidth: '33px' }} className="text-center">#</th>
								<th style={{ width: '14%' }}>{t('user')}</th>
								<th style={{ width: '12%' }}>{t('payment')}</th>
								<th style={{ width: '20%' }}>{t('type')}</th>
								<th style={{ width: '27%' }}>{t('note')}</th>
								<th style={{ width: '14%' }} className="text-center">{t('date')}</th>
								<th style={{ width: '13%' }} className="text-end">{t('amount')}</th>
							</tr>
						</thead>
						<tbody>
							{data.map((item, index) => (
								<tr key={index}>
									<td className="text-center">{index + 1}</td>
									<td className="td-ellipsis">{item.created_by || item.cashier_login || '—'}</td>
									<td className="td-ellipsis">{item.payment_type_name || '—'}</td>
									<td className="td-ellipsis">{item.payment_purpose_name || '—'}</td>
									<td className="td-ellipsis">{item.note || '—'}</td>
									<td className="text-center text-nowrap">
										{formatDate(item.created_at, 'dd.MM.yyyy HH:mm')}
									</td>
									<td className="text-end text-nowrap text-danger">
										{formatMoney(item.amount)}{item.is_usd ? ' $' : ''}
									</td>
								</tr>
							))}
							{data.length === 0 &&
								<tr><td colSpan="7" className="text-center text-muted py-4">{t('list_empty')}</td></tr>
							}
						</tbody>
					</table>
				</div>
			</Modal.Body>
		</Modal>
	)
}

export default SummaryExpense
